var render, staticRenderFns
import script from "./PaymentPrincipal.vue?vue&type=script&lang=js"
export * from "./PaymentPrincipal.vue?vue&type=script&lang=js"
import style0 from "./PaymentPrincipal.vue?vue&type=style&index=0&id=3a88a02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a88a02c",
  null
  
)

export default component.exports